import React, { useState, useEffect } from 'react'
import TextInput from '../TextInput/TextInput'
import FormError from '../FormError/FormError'

export default function TextInputGroup({ children, className, style, error }) {
    let classes = 'textInputGroup'
    if (className) classes += ' ' + className
    return (
        <div className={classes} style={style}>
            <div className='textInputGroup__inputs'>{children}</div>
            {!!error && <FormError>{error}</FormError>}
        </div>
    )
}
